import { useState } from 'react';
import { Link } from 'react-router-dom';
import VideoCard from '@/components/base/VideoCard';
import { videos } from '@/mocks/videos';
import type { categories } from '@/mocks/videos';

type CategorySlug = (typeof categories)[number]['slug'];

interface VideoGridProps {
  categorySlug: CategorySlug;
}

const PAGE_SIZE = 9;

export default function VideoGrid({ categorySlug }: VideoGridProps) {
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);
  const filtered = videos.filter((v) => v.category === categorySlug);
  const displayed = filtered.slice(0, visibleCount);
  const hasMore = visibleCount < filtered.length;
  const allCategories = [
    { slug: 'wanghong-fanche' as const, name: '网红翻车', icon: 'ri-emotion-sad-line' },
    { slug: 'mingxing-bagua' as const, name: '明星八卦', icon: 'ri-star-line' },
    { slug: 'remen-baoliao' as const, name: '热门爆料', icon: 'ri-fire-line' },
    { slug: 'fancha-shipin' as const, name: '反差视频', icon: 'ri-contrast-2-line' },
  ];

  return (
    <section className="w-full py-14 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-wrap items-center gap-2 mb-8">
          {allCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                cat.slug === categorySlug
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              <i className={`${cat.icon} text-sm`}></i>
              {cat.name}
            </Link>
          ))}
          <span className="text-foreground-400 text-sm ml-auto">
            共 {filtered.length} 个视频
          </span>
        </div>

        {displayed.length === 0 ? (
          <div className="text-center py-20">
            <span className="w-16 h-16 flex items-center justify-center rounded-full bg-background-100 mx-auto mb-4">
              <i className="ri-video-line text-foreground-400 text-2xl"></i>
            </span>
            <p className="text-foreground-500 text-sm">暂无该分类视频，敬请期待</p>
          </div>
        ) : (
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-product-shop>
              {displayed.map((video) => (
                <VideoCard key={video.id} {...video} />
              ))}
            </div>

            {hasMore && (
              <div className="flex justify-center mt-10">
                <button
                  onClick={() => setVisibleCount((prev) => prev + PAGE_SIZE)}
                  className="flex items-center gap-2 px-6 py-3 bg-background-100 hover:bg-background-200 text-foreground-700 rounded-full text-sm font-medium transition-colors cursor-pointer"
                >
                  加载更多
                  <i className="ri-arrow-down-line"></i>
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </section>
  );
}